import type { Dictionary } from '../dictionary.types'

const en: Dictionary = {
  ItemCountOfTotalCount: 'Item {{index}} of {{pagerCount}}',
  'Currently Active': 'Currently Active',
}

export default en
